import React from "react";

/** Property note, Prev / lot selector / Next, and the styles the lot list uses. */
export default function LotNavigation({
  cachedTotal,
  handleGoToLot,
  isLotListOpen,
  isWidraw,
  lotNumber,
  next,
  nextButton,
  previous,
  previousButton,
  property,
  searchTerm,
  setIsLotListOpen,
  setSearchTerm,
}) {
  return (
    <>
                    {/* 1. PROPERTY DESCRIPTION */}
                    <div
                      style={{
                        display: isWidraw === 1 ? "none" : "block",
                        fontSize: "13px",
                        color: "#666",
                        marginBottom: "15px",
                        fontStyle: "italic",
                        lineHeight: 1.5,
                        letterSpacing: "0.2px",
                        fontFamily: "'Georgia', serif",
                      }}
                      dangerouslySetInnerHTML={{
                        __html:
                          property === null
                            ? ""
                            : property
                                .replace(/\n/g, "<br />")
                                .replace(/PROVENANCE/g, ""),
                      }}
                    ></div>

                    {/* 2. NAVIGATION BLOCK */}
                    <div
                      className="d-flex justify-content-between align-items-center"
                      style={{
                        marginBottom: "20px",
                        padding: "15px 0", // Increased padding for a more luxurious feel
                        borderTop: "1px solid #e0e0e0",
                        borderBottom: "1px solid #e0e0e0",
                        position: "relative",
                      }}
                    >
                      {/* PREVIOUS */}
                      {previous !== 0 ? (
                        <button
                          onClick={previousButton}
                          style={{
                            background: "none",
                            border: "none",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            cursor: "pointer",
                            transition: "0.2s",
                          }}
                          onMouseOver={(e) =>
                            (e.currentTarget.style.opacity = "0.5")
                          }
                          onMouseOut={(e) => (e.currentTarget.style.opacity = "1")}
                        >
                          <i
                            className="fa fa-angle-left"
                            style={{ fontSize: "18px", color: "#000" }}
                          ></i>
                          <span
                            style={{
                              fontSize: "11px",
                              fontWeight: 700,
                              color: "#000",
                              letterSpacing: "1.5px",
                              textTransform: "uppercase",
                            }}
                          >
                            Prev
                          </span>
                        </button>
                      ) : (
                        <div style={{ width: "60px" }} />
                      )}

                      {/* CUSTOM BOX SELECTOR */}
                      <div style={{ position: "relative" }}>
                        <div
                          onClick={() => setIsLotListOpen(!isLotListOpen)}
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            padding: "0 25px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "10px",
                              letterSpacing: "2px",
                              color: "#999",
                              fontWeight: "600",
                            }}
                          >
                            LOT
                          </span>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <h2
                              style={{
                                color: "#000",
                                fontWeight: "400",
                                fontSize: "1.6rem",
                                margin: 0,
                                fontFamily: '"Bell MT", Georgia, "Times New Roman", serif',
                              }}
                            >
                              {lotNumber}
                            </h2>
                            <i
                              className={`fa fa-angle-${
                                isLotListOpen ? "up" : "down"
                              }`}
                              style={{ fontSize: "12px", color: "#000" }}
                            ></i>
                          </div>
                        </div>

                        {/* THE BOX (Professional Searchable List) */}
                        {isLotListOpen && (
                          <div
                            style={{
                              position: "absolute",
                              top: "55px",
                              left: "50%",
                              transform: "translateX(-50%)",
                              width: "240px", // Slightly wider
                              backgroundColor: "#fff",
                              border: "1px solid #e0e0e0", // Lighter border
                              boxShadow: "0 10px 25px rgba(0,0,0,0.08)", // Softer shadow
                              zIndex: 1000,
                              animation: "fadeIn 0.2s ease-out",
                            }}
                          >
                            {/* Search Input Container */}
                            <div
                              style={{
                                padding: "12px",
                                borderBottom: "1px solid #f0f0f0",
                              }}
                            >
                              <div style={{ position: "relative" }}>
                                <i
                                  className="fa fa-search"
                                  style={{
                                    position: "absolute",
                                    left: "10px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    fontSize: "12px",
                                    color: "#aaa",
                                  }}
                                ></i>
                                <input
                                  type="text"
                                  placeholder="Find Lot Number..."
                                  autoFocus
                                  value={searchTerm}
                                  onChange={(e) => setSearchTerm(e.target.value)}
                                  style={{
                                    width: "100%",
                                    border: "1px solid #eee",
                                    padding: "8px 8px 8px 30px",
                                    fontSize: "13px",
                                    outline: "none",
                                    backgroundColor: "#fafafa",
                                    borderRadius: "2px",
                                  }}
                                />
                              </div>
                            </div>

                            <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                              {Array.from({ length: cachedTotal }, (_, i) => i + 1)
                                .filter((num) =>
                                  num.toString().includes(searchTerm || "")
                                )
                                .map((num) => (
                                  <div
                                    key={num}
                                    onClick={() => {
                                      handleGoToLot(num);
                                      setIsLotListOpen(false);
                                      setSearchTerm("");
                                    }}
                                    style={{
                                      padding: "12px 20px",
                                      textAlign: "left", // Left align for more professional look
                                      cursor: "pointer",
                                      fontSize: "13px",
                                      letterSpacing: "0.5px",
                                      backgroundColor:
                                        lotNumber === num
                                          ? "#f5f5f5"
                                          : "transparent",
                                      color: "#333",
                                      fontWeight: lotNumber === num ? "700" : "400",
                                      borderBottom: "1px solid #fafafa",
                                    }}
                                    className="lot-option-gallery"
                                  >
                                    <span
                                      style={{ color: "#999", marginRight: "10px" }}
                                    >
                                      Lot
                                    </span>{" "}
                                    {num}
                                  </div>
                                ))}
                              {/* No results message */}
                              {Array.from({ length: cachedTotal }).filter((_, i) =>
                                (i + 1).toString().includes(searchTerm || "")
                              ).length === 0 && (
                                <div
                                  style={{
                                    padding: "20px",
                                    textAlign: "center",
                                    color: "#999",
                                    fontSize: "12px",
                                  }}
                                >
                                  No lots found
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>

                      {/* NEXT */}
                      {next !== 0 ? (
                        <button
                          onClick={nextButton}
                          style={{
                            background: "none",
                            border: "none",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            cursor: "pointer",
                            transition: "0.2s",
                          }}
                          onMouseOver={(e) =>
                            (e.currentTarget.style.opacity = "0.5")
                          }
                          onMouseOut={(e) => (e.currentTarget.style.opacity = "1")}
                        >
                          <span
                            style={{
                              fontSize: "11px",
                              fontWeight: 700,
                              color: "#000",
                              letterSpacing: "1.5px",
                              textTransform: "uppercase",
                            }}
                          >
                            Next
                          </span>
                          <i
                            className="fa fa-angle-right"
                            style={{ fontSize: "18px", color: "#000" }}
                          ></i>
                        </button>
                      ) : (
                        <div style={{ width: "60px" }} />
                      )}
                    </div>
                    <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translate(-50%, -10px); }
          to { opacity: 1; transform: translate(-50%, 0); }
        }
        .lot-option-gallery {
          transition: background-color 0.2s ease, color 0.2s ease;
        }
        .lot-option-gallery:hover {
          background-color: #f2f2f2 !important; /* LIGHT GRAY HOVER */
          color: #000 !important;
        }
        /* Thin elegant scrollbar */
        div::-webkit-scrollbar {
          width: 5px;
        }
        div::-webkit-scrollbar-track {
          background: #f9f9f9;
        }
        div::-webkit-scrollbar-thumb {
          background: #d1d1d1;
          border-radius: 10px;
        }
        div::-webkit-scrollbar-thumb:hover {
          background: #999;
        }
      `}</style>
    </>
  );
}
